import ChartColors from './ChartColors.js';

class ControlColors {
  constructor(options = {}, base) {
    this.chart = new ChartColors(options.chart, base === null || base === void 0 ? void 0 : base.chart);
  }
}

export { ControlColors as default };
